<template>
  <v-card class="dialog-voucher">

    <v-card-title
      class="dialog-title justify-center"
    >
      {{ isDetalhes ? 'Detalhes do Convênio' : 'Ler Voucher' }}

      <v-btn
        icon
        absolute
        right
        class="close-button"
        @click="$emit('fechar')"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text v-if="voucher" class="pa-0">

      <div class="voucher-header py-3 text-xs-center" style="background-color: #fcfcfc;">

        <div class="mb-1">
          <v-chip
            v-if="voucher.percentual_desconto"
            outline
            color="primary"
            class="font-weight-bold"
            small
          >
            <v-icon left size="16">local_offer</v-icon>
            {{ voucher.percentual_desconto }}% DE DESCONTO
          </v-chip>
        </div>

        <div class="headline font-weight-black primary--text" style="letter-spacing: 1px;">
          {{ voucher.codigo }}
        </div>

        <v-layout
          wrap
          class="mt-4 mb-2"
          v-if="voucher.valor_original !== undefined && voucher.valor_final !== undefined"
        >
          <v-flex xs4 class="text-xs-center">
            <div class="caption grey--text text--darken-1 mb-1">
              Valor Original
            </div>
            <div class="body-2 font-weight-medium" style="text-decoration: line-through;">
              R$ {{ parseFloat(voucher.valor_original).toFixed(2).replace('.', ',') }}
            </div>
          </v-flex>

          <v-flex xs4 class="text-xs-center" style="border-left: 1px solid #eeeeee; border-right: 1px solid #eeeeee;">
            <div class="caption grey--text text--darken-1 mb-1">
              Desconto
            </div>
            <div class="body-2 font-weight-bold error--text">
              - R$ {{ parseFloat(voucher.valor_desconto).toFixed(2).replace('.', ',') }}
            </div>
          </v-flex>

          <v-flex xs4 class="text-xs-center">
            <div class="caption font-weight-bold mb-1" style="color: #4caf50;">
              Valor a Pagar
            </div>
            <div class="title font-weight-black success--text mt-1">
              R$ {{ parseFloat(voucher.valor_final).toFixed(2).replace('.', ',') }}
            </div>
          </v-flex>
        </v-layout>

      </div>

      <template v-if="isDetalhes">

        <div class="voucher-info pa-3">

          <div class="section-title">
            Informações do voucher
          </div>

          <v-layout wrap>

            <v-flex
              xs12
              sm6
              class="info-item"
            >
              <div class="caption grey--text text--darken-1">
                Data
              </div>

              <div class="body-2 font-weight-medium">
                {{ formatarData(voucher.data_gerado) }}
              </div>
            </v-flex>

            <v-flex
              xs12
              sm6
              class="info-item info-item-right"
            >
              <div class="caption grey--text text--darken-1">
                Hora
              </div>

              <div class="body-2 font-weight-medium">
                {{ formatarHora(voucher.hora_gerado) }}
              </div>
            </v-flex>

            <v-flex
              xs12
              sm6
              class="info-item"
            >
              <div class="caption grey--text text--darken-1">
                Status
              </div>

              <div
                class="body-2 font-weight-bold"
                :class="
                  voucher.disponivel
                    ? 'success--text'
                    : 'error--text'
                "
              >
                {{
                  voucher.disponivel
                    ? 'Disponível'
                    : 'Utilizado/Inativo'
                }}
              </div>
            </v-flex>

            <v-flex
              v-if="
                !voucher.disponivel &&
                voucher.data_inativado
              "
              xs12
              sm6
              class="info-item info-item-right"
            >
              <div class="caption grey--text text--darken-1">
                Inativado em
              </div>

              <div class="body-2 font-weight-medium">
                {{ formatarData(voucher.data_inativado) }}
                às
                {{ formatarHora(voucher.hora_inativado) }}
              </div>
            </v-flex>

            <v-flex
              v-if="voucher.empresa_beneficiada"
              xs12
              sm6
              class="info-item"
            >
              <div class="caption grey--text text--darken-1">
                Empresa Beneficiada
              </div>

              <div class="body-2 font-weight-medium">
                {{ voucher.empresa_beneficiada.nome_fantasia }}
              </div>
            </v-flex>

            <v-flex
              v-if="voucher.aplicativo_origem"
              xs12
              sm6
              :class="
                voucher.empresa_beneficiada
                  ? 'info-item info-item-right'
                  : 'info-item'
              "
            >
              <div class="caption grey--text text--darken-1">
                Gerado pelo App
              </div>

              <div class="body-2 font-weight-medium">
                {{ voucher.aplicativo_origem }}
              </div>
            </v-flex>

          </v-layout>

        </div>

        <template v-if="voucher.usuario_beneficiado">

          <div class="section-header">
            <div class="section-header-title">
              Cliente Beneficiado
            </div>
          </div>

          <div class="voucher-info pa-3">

            <v-layout wrap>

              <v-flex
                xs12
                sm6
                class="info-item"
              >
                <div class="caption grey--text text--darken-1">
                  ID
                </div>

                <div class="body-2 font-weight-bold">
                  {{
                    voucher.usuario_beneficiado.id_cliente ||
                    voucher.usuario_beneficiado.id
                  }}
                </div>
              </v-flex>

              <v-flex
                v-if="voucher.usuario_beneficiado.pessoa"
                xs12
                sm6
                class="info-item info-item-right"
              >
                <div class="caption grey--text text--darken-1">
                  Nome
                </div>

                <div class="body-2 font-weight-bold">
                  {{
                    voucher.usuario_beneficiado.pessoa.nome_completo ||
                    voucher.usuario_beneficiado.pessoa.nome
                  }}
                </div>
              </v-flex>

              <v-flex
                v-if="
                  voucher.usuario_beneficiado.pessoa &&
                  voucher.usuario_beneficiado.pessoa.cpf
                "
                xs12
                sm6
                class="info-item"
              >
                <div class="caption grey--text text--darken-1">
                  CPF
                </div>

                <div class="body-2">
                  {{ voucher.usuario_beneficiado.pessoa.cpf }}
                </div>
              </v-flex>

              <v-flex
                v-if="
                  voucher.usuario_beneficiado.pessoa &&
                  voucher.usuario_beneficiado.pessoa.telefone
                "
                xs12
                sm6
                class="info-item info-item-right"
              >
                <div class="caption grey--text text--darken-1">
                  Telefone
                </div>

                <div class="body-2">
                  {{ voucher.usuario_beneficiado.pessoa.telefone }}
                </div>
              </v-flex>

              <v-flex
                v-if="
                  voucher.usuario_beneficiado.pessoa &&
                  voucher.usuario_beneficiado.pessoa.email
                "
                xs12
                class="info-item info-item-full"
              >
                <div class="caption grey--text text--darken-1">
                  E-mail
                </div>

                <div class="body-2">
                  {{ voucher.usuario_beneficiado.pessoa.email }}
                </div>
              </v-flex>

            </v-layout>

          </div>

        </template>

        <template
          v-if="
            !voucher.disponivel &&
            voucher.frentista_leitura
          "
        >

          <div class="section-header">
            <div class="section-header-title">
              Lido Por
            </div>
          </div>

          <div class="voucher-info pa-3">

            <v-layout wrap>

              <v-flex
                xs12
                sm6
                class="info-item"
              >
                <div class="caption grey--text text--darken-1">
                  Matrícula
                </div>

                <div class="body-2 font-weight-bold">
                  {{ voucher.frentista_leitura.matricula }}
                </div>
              </v-flex>

              <v-flex
                xs12
                sm6
                class="info-item info-item-right"
              >
                <div class="caption grey--text text--darken-1">
                  Nome
                </div>

                <div class="body-2 font-weight-bold">
                  {{ voucher.frentista_leitura.nome }}
                </div>
              </v-flex>

            </v-layout>

          </div>

        </template>

      </template>

      <template v-else>

        <v-divider></v-divider>

        <v-card-text>

          <v-layout
            justify-center
            wrap
            class="mb-2"
          >

            <v-flex
              xs12
              class="pin-header"
            >
              <h6 class="pin-title">
                Digite o PIN do {{ frentistaSelecionado && frentistaSelecionado.empresa ? 'funcionário' : 'frentista' }} responsável
              </h6>

              <v-btn
                round
                color="primary"
                small
                class="alterar-frentista"
                @click="selecionarFrentista = true"
              >
                Alterar {{ frentistaSelecionado && frentistaSelecionado.empresa ? 'funcionário' : 'frentista' }}
              </v-btn>
            </v-flex>

            <v-flex
              xs12
              class="frentista-container"
            >

              <div class="frentista-content">

                <div class="frentista-icon">
                  <v-icon size="40">
                    engineering
                  </v-icon>
                </div>

                <div class="frentista-dados">

                  <h4>
                    Lido por: {{ frentistaSelecionado.nome }}
                  </h4>

                  <h4>
                    Matricula: {{ frentistaSelecionado.matricula }}
                  </h4>

                </div>

              </div>

            </v-flex>

          </v-layout>

          <Pin
            v-if="!autenticado"
            :frentista="frentistaSelecionado"
            @autenticado="autenticado = true"
          />

          <h3
            v-else
            class="success--text text-xs-center mt-3 mb-3"
          >
            A leitura já pode ser realizada
          </h3>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>

          <v-btn
            block
            large
            color="primary"
            :disabled="!autenticado"
            flat
            :loading="loading"
            @click="$emit('ler')"
          >
            Realizar Leitura
          </v-btn>

        </v-card-actions>

      </template>

    </v-card-text>

    <v-dialog
      v-if="selecionarFrentista"
      v-model="selecionarFrentista"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <selecionar-frentista
        @fechar="
          selecionarFrentista = false;
          autenticado = false
        "
      />
    </v-dialog>

  </v-card>
</template>

<script>
import Pin from '@/components/Pin'
import SelecionarFrentista from '@/components/dialogs/DialogSelecionarFrentista'

export default {
  components: {
    Pin,
    SelecionarFrentista
  },

  props: {
    voucher: {
      type: Object,
      required: true
    },

    modo: {
      type: String,
      default: 'detalhes'
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    autenticado: false,
    selecionarFrentista: false
  }),

  computed: {
    isDetalhes () {
      return this.modo === 'detalhes'
    },

    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    }
  },

  methods: {
    formatarData (dataIso) {
      if (!dataIso) return ''

      const partes = dataIso.split('-')

      if (partes.length !== 3) {
        return dataIso
      }

      return `${partes[2]}/${partes[1]}/${partes[0]}`
    },

    formatarHora (hora) {
      if (!hora) return ''

      const valor = String(hora)

      const match = valor.match(
        /(\d{2}:\d{2}:\d{2})/
      )

      return match ? match[1] : valor
    }
  },

  watch: {
    voucher () {
      this.autenticado = false
    },

    modo () {
      this.autenticado = false
    }
  }
}
</script>

<style scoped>
.dialog-voucher {
  width: 100%;
  max-width: 900px;
  overflow: hidden;
}

.dialog-title {
  position: relative;
  min-height: 58px;
  padding: 14px 55px;
  font-size: 1.5em;
  font-weight: 700;
}

.close-button {
  top: 8px;
  right: 8px;
}

.voucher-header {
  padding: 14px 20px;
  border-bottom: 1px solid #e0e0e0;
}

.voucher-title {
  font-size: 1.35em;
  font-weight: 700;
}

.voucher-desconto-destaque {
  margin-top: 4px;
  color: #00577a;
  font-size: 1.05em;
  font-weight: 700;
}

.section-title {
  margin-bottom: 8px;
  text-align: center;
  font-size: 1em;
  font-weight: 700;
}

.section-header {
  padding: 7px 16px;
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  background: #fafafa;
}

.section-header-title {
  text-align: center;
  color: #666666;
  font-size: 0.8em;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.voucher-info {
  border-bottom: 1px solid #f5f5f5;
}

.info-item {
  min-height: 50px;
  margin-bottom: 0;
  padding: 5px 25px;
  text-align: center;
}

.info-item-right {
  border-left: 1px solid #eeeeee;
}

.info-item-full {
  min-height: 45px;
  margin-top: 3px;
  padding-top: 8px;
  border-top: 1px solid #f5f5f5;
}

.info-item .caption {
  margin-bottom: 1px;
}

.pin-header {
  position: relative;
  min-height: 42px;
  text-align: center;
}

.pin-title {
  margin: 0;
  font-size: 1.1em;
  font-weight: 700;
  text-align: center;
}

.alterar-frentista {
  position: absolute;
  top: -5px;
  right: 0;
}

.frentista-container {
  position: relative;
  left: -40px;
  display: flex;
  justify-content: center;
  margin-top: 2px;
}

.frentista-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 330px;
}

.frentista-icon {
  width: 60px;
  margin-right: 8px;
  text-align: center;
  transform: translateX(-8px);
}

.frentista-dados {
  text-align: left;
}

.frentista-dados h4 {
  margin-top: 3px;
  margin-bottom: 3px;
}

@media (max-width: 599px) {
  .dialog-title {
    min-height: 52px;
    padding: 12px 45px 12px 20px;
    font-size: 1.2em;
  }

  .close-button {
    top: 4px;
    right: 4px;
  }

  .voucher-header {
    padding: 10px 15px;
  }

  .voucher-header .v-icon {
    font-size: 30px !important;
  }

  .voucher-title {
    font-size: 1.15em;
  }

  .voucher-desconto-destaque {
    font-size: 0.95em;
  }

  .voucher-info {
    padding: 8px !important;
  }

  .info-item {
    min-height: 45px;
    padding: 5px 10px;
  }

  .info-item-right {
    border-left: none;
  }

  .info-item-full {
    border-top: none;
    margin-top: 0;
    padding-top: 5px;
  }

  .section-title {
    margin-bottom: 5px;
  }

  .section-header {
    padding: 6px 10px;
  }

  .pin-header {
    padding-right: 0;
  }

  .pin-title {
    padding-right: 0;
    margin-bottom: 45px;
  }

  .alterar-frentista {
    top: 32px;
    right: 50%;
    transform: translateX(50%);
  }

  .frentista-content {
    width: 300px;
  }

  .frentista-icon {
    transform: translateX(-5px);
  }
}

@media (max-width: 380px) {
  .dialog-title {
    font-size: 1.1em;
  }

  .voucher-title {
    font-size: 1.05em;
  }

  .voucher-desconto-destaque {
    font-size: 0.9em;
  }

  .info-item {
    padding: 4px 5px;
  }

  .body-2 {
    font-size: 0.85rem !important;
  }

  .caption {
    font-size: 0.72rem !important;
  }
}
</style>
